module.exports = "<div class=\"notices__container\">\n  <div class=\"row align-center align-middle\">\n    <div class=\"column small-12 xlarge-6\">\n      <div class=\"notices__wrapper text-justify\" [innerHTML]=\"legalNotices\">\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/legalnotices/legalnotices.component.html
// module id = ./src/app/screens/legalnotices/legalnotices.component.html
// module chunks = main